import useLocalizedCurrencyFormatter from '@/hooks/useLocalizedCurrencyFormatter';
import type Konva from 'konva';
import React, { useEffect, useRef, useState } from 'react';
import { Group, Rect, Text } from 'react-konva';

interface PriceStripProps {
  price: number;
  width: number;
  xOffset: number;
  yOffset: number;
}

const PriceStrip: React.FC<PriceStripProps> = ({
  price,
  width,
  xOffset,
  yOffset,
}) => {
  const [stripWidth, setStripWidth] = useState(width);
  const textRef = useRef<Konva.Text | null>(null);
  const currencyFormatter = useLocalizedCurrencyFormatter();
  const formattedPrice = currencyFormatter
    .format(price)
    .replace(/[^\d,.]/g, '');
  const stripHeight = 16;
  const radius = 4;
  const textHeight = 10;
  const padding = (stripHeight - textHeight) / 2;

  useEffect(() => {
    if (textRef.current) {
      const textNode = textRef.current;
      const textWidth = textNode.getTextWidth();
      const requiredWidth = textWidth + padding * 2; // Use padding for both sides

      setStripWidth(Math.max(width, requiredWidth));
    }
  }, [width, padding]);

  return (
    <Group>
      <Rect
        width={stripWidth}
        height={stripHeight}
        fill="#1a237e"
        cornerRadius={radius}
        x={xOffset}
        y={yOffset}
      />
      <Text
        ref={textRef}
        text={formattedPrice}
        fontSize={10}
        fontFamily="Manrope"
        fill="#FFFFFF"
        width={stripWidth}
        align="center"
        x={xOffset}
        y={yOffset + padding}
      />
    </Group>
  );
};

export default PriceStrip;
